import { z } from "zod";

/** The tabs of a feed's composition: its papers by health field, and by subject. */
export const COMPOSITION_TABS = [
  { value: "fields", label: "Health fields" },
  { value: "subjects", label: "Subjects" },
] as const;

/** The tabs of a feed's page: its papers and query, and its runs. */
export const FEED_TABS = [
  { value: "overview", label: "Overview" },
  { value: "runs", label: "Runs" },
] as const;

/** What a feed's page is told by its URL: which tab to open, and which composition tab. */
export const feedDetailFiltersSchema = z.object({
  tab: z.enum(["overview", "runs"]).default("overview"),
  composition: z.enum(["fields", "subjects"]).default("fields"),
});
